export { default } from './Link';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Link/index.js
// module id = 590
// module chunks = 121